import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=5cb714ce"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb714ce')) {
      api.createRecord('5cb714ce', component.options)
    } else {
      api.reload('5cb714ce', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=5cb714ce", function () {
      api.rerender('5cb714ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/Card.vue"
export default component.exports